module.exports = __webpack_public_path__ + "static/media/cacc.4edff024.svg";